<template>
  <div class="about hue page">
    <subpage-layout :theme="'dark'" :name="this.$route.name">
      <template v-slot:hero-image>
        <img src="../assets/img/hero-img-8.jpg" />
      </template>

      <template v-slot:description>
        <h2>My Story</h2>

        <p class="col-layout">
          <strong>
            My name is Laura. I am a Frontend Developer and UI Designer.
          </strong>
          <br />I love exploring new technology and spend an embarrassingly
          large part of my spare time on <strong>creative coding</strong>,
          <strong>animation</strong> and
          <strong>data visualization.</strong>
          <br />I spent my formative years working as a Digital Designer for
          London eCommerce shops so I bring a great eye for design and a wealth
          of experience in UI, UX, newsletter design and creation.
          <br />Additionally, I have 5 years of experience crafting front-ends
          in <strong>Drupal 7, 8</strong> and <strong>Wordpress</strong>.
          <br />
          <br />My special interest is all things
          <strong>Vue, Nuxt and Jamstack</strong>
          coupled with expertise in animation, illustration and visualization of
          data.
        </p>
      </template>

      <template v-slot:skills>
        <featured-temp :kind="'sm'">
          <template v-slot:featured-title>Skills Front-End</template>
          <template v-slot:default>
            <ul>
              <li>HTML / CSS / SCSS</li>
              <li>Javascript</li>
              <li>Vue / Nuxt</li>
              <li>Angular</li>
              <li>Wordpress / Drupal</li>
              <li>GSAP</li>
              <li>D3.js, HTML5 Canvas</li>
              <li>StencilJs / Web Components</li>
              <li>Puppeteer</li>
              <li>Cypress / Mocha / Chai</li>
              <li>Git</li>
            </ul>
          </template>
        </featured-temp>
        <featured-temp :kind="'sm'">
          <template v-slot:featured-title>Skills UI Design</template>
          <template v-slot:default>
            <ul>
              <li>Photoshop</li>
              <li>Illustrator</li>
              <li>Sketch</li>
              <li>Adobe XD</li>
              <li>Webflow</li>
              <li>Newsletter Design & Creation</li>
            </ul>
          </template>
        </featured-temp>
      </template>

      <template v-slot:cards></template>
    </subpage-layout>
  </div>
</template>

<script>
import subpageLayout from "@/components/SubpageLayout";
import featuredTemp from "@/components/FeaturedTemp";
export default {
  name: "about",

  components: {
    subpageLayout,
    featuredTemp,
  },
};
</script>

<style lang="scss">
.col-layout {
  column-count: 1;
  @include breakpoint(md) {
    column-count: 2;
  }
}
</style>
